import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component } from 'react';
import { TooltipMenu, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import swal from 'sweetalert2';
import DateTime from '_class/DateTime';
import User from '_class/User';
import { getSection } from 'actions/sections';
import { getTaskDetails, setActiveAssignment, getMicrosoftAssignmentDetails } from 'actions/assignments';
import { getScheduleItem, deleteCalendarEvent, updateCalendarEvent, clearScheduleItem } from 'actions/schedule';
import { submitAttendence, updateAttendance, clearForecast } from 'actions/absence';
import { setPageTitle, setPageActions } from 'actions/header';
import { getParameterByName } from 'helpers/url';
import Modal from 'containers/Modals/Modal';
import CalendarEvent from 'containers/Forms/CalendarEvent';
import PostContent from 'components/Presentation/PostContent';
import UserAbsence from 'components/List/UserAbsence';
import { Block, Button, Icon, getActiveLanguage } from '@haldor/ui';
import { Expandable, Spinner } from 'UI';
import AssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';
import DisplayAssignment from 'components/BlockEditor/Blocks/AssignmentBlock/DisplayAssignment';
import AssignmentSelect from 'containers/Forms/Partials/AssignmentSelect';
import './_Lesson.scss';

var SingleLesson = /*#__PURE__*/function (_Component) {
  _inherits(SingleLesson, _Component);

  var _super = _createSuper(SingleLesson);

  function SingleLesson(props) {
    var _this;

    _classCallCheck(this, SingleLesson);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getLockedStatus", function (item) {
      var total = item === null || item === void 0 ? void 0 : item.totalTasks;
      var open = (item === null || item === void 0 ? void 0 : item.lockedWorkspaces) === 0 ? item === null || item === void 0 ? void 0 : item.totalTasks : item === null || item === void 0 ? void 0 : item.lockedWorkspaces;
      return {
        open: open,
        total: total
      };
    });

    _defineProperty(_assertThisInitialized(_this), "redirect", function () {
      if (getParameterByName('redirect') != null) {
        if (getParameterByName('redirect') == 'list') {
          _this.props.history.push('/report/attendance');
        }

        if (getParameterByName('redirect') == 'back') {
          _this.props.history.goBack();
        }
      } else {
        _this.props.history.push('/schedule');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAbsenceSubmit", function (values) {
      var schedule = _this.props.schedule;
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var invalidAbsence, prompt;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  invalidAbsence = values.find(function (absence) {
                    if (absence.type == 'INVALID_LATE' || absence.type == 'VALID_LATE') {
                      return absence.lateDuration == null || absence.lateDuration == 0 || isNaN(absence.lateDuration);
                    }

                    return false;
                  });

                  if (!(invalidAbsence != null)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 4;
                  return swal.fire({
                    title: _this.props.translate('report-absence'),
                    text: _this.props.translate('you-have-absence-set-to-zero'),
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: _this.props.translate('okey')
                  });

                case 4:
                  prompt = _context.sent;

                  if (!(prompt.value == null)) {
                    _context.next = 8;
                    break;
                  }

                  resolve(0);
                  return _context.abrupt("return", false);

                case 8:
                  if (schedule.attendanceReported != null) {
                    _this.props.updateAttendance(values, _this.props.match.params.id).then(function () {
                      resolve(1);

                      _this.redirect();
                    });
                  } else {
                    _this.props.submitAttendence(values, _this.props.match.params.id).then(function () {
                      schedule.attendanceReported = new DateTime().getTimeStamp();
                      resolve(1);

                      _this.redirect();
                    });
                  }

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "searchAssigment", function (value) {
      var _value$reference;

      if (_this.props.group != null) {
        value.section = _this.props.group;
      }

      var items = (_value$reference = value === null || value === void 0 ? void 0 : value.reference) !== null && _value$reference !== void 0 ? _value$reference : value;

      _this.setState(function (prevState) {
        return {
          selectedAssignments: items ? prevState.selectedAssignments.filter(function (x) {
            return x.id !== items.id;
          }).concat(items) : prevState.selectedAssignments,
          createEvent: false,
          hasMadeChange: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchForm", function () {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'Search assignment'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAssignment", function () {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'Create assignment'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupAssignment", function () {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'Create group assignment'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (skip == true) {
        _this.setState({
          createEvent: !_this.state.createEvent
        });
      } else {
        swal.fire({
          title: _this.props.translate('are-you-sure'),
          text: _this.props.translate('close-form-prompt'),
          showCancelButton: true,
          cancelButtonText: _this.props.translate('No'),
          confirmButtonText: _this.props.translate('Yes')
        }).then(function (result) {
          if (result.value != null) {
            _this.setState({
              createEvent: !_this.state.createEvent
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeModalAssignment", function (value) {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssignments: _this.props.createdGroupAssignment ? [].concat(_toConsumableArray(prevState.selectedAssignments), [_this.props.createdGroupAssignment]) : prevState.selectedAssignments,
            createEvent: false,
            hasMadeChange: _this.props.createdGroupAssignment ? true : false
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeGroupModal", function () {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssignments: _this.props.createdAssignments ? [].concat(_toConsumableArray(prevState.selectedAssignments), [_this.props.createdAssignments[0]]) : prevState.selectedAssignments,
            createEvent: false,
            hasMadeChange: _this.props.createdAssignments ? true : false
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEdit", function () {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        editForm: !_this.state.editForm
      });

      if (reload) {
        _this.props.getScheduleItem(_this.props.match.params.id).then(function () {
          var _this$props$schedule;

          _this.props.setPageTitle((_this$props$schedule = _this.props.schedule) === null || _this$props$schedule === void 0 ? void 0 : _this$props$schedule.title);

          if (reload !== null && reload !== void 0 && reload.relationships) {
            var _this$props, _this$props$schedule2;

            _this.setState({
              loadingAssignments: true,
              selectedAssignments: []
            });

            var promises = (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$schedule2 = _this$props.schedule) === null || _this$props$schedule2 === void 0 ? void 0 : _this$props$schedule2.relationships.map(function (items) {
              var containsLetters = /[a-zA-Z]/.test(items.referenceId);

              if (containsLetters) {
                return new Promise(function (resolve) {
                  _this.props.getMicrosoftAssignmentDetails(items.referenceId).then(function () {
                    if (_this.props.details != null) {
                      _this.props.details.section = _this.props.group;

                      _this.setState(function (prevState) {
                        {
                          return {
                            selectedAssignments: [].concat(_toConsumableArray(prevState.selectedAssignments), [_this.props.details])
                          };
                        }
                      });

                      resolve(1);
                    }
                  });
                });
              } else {
                return new Promise(function (resolve) {
                  _this.props.getTaskDetails(items.referenceId).then(function () {
                    _this.setState({
                      selectedAssignments: [].concat(_toConsumableArray(_this.state.selectedAssignments), [_this.props.assignment])
                    });

                    resolve(1);
                  });
                });
              }
            });
            Promise.all(promises).then(function () {
              _this.setState({
                loadingAssignments: false
              });
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDescriptionTogle", function (open) {
      _this.setState({
        descriptionOpen: open
      });

      localStorage.setItem('haldor-lesson-description', JSON.stringify(open));
    });

    _defineProperty(_assertThisInitialized(_this), "onAssigmentsToggle", function (open) {
      _this.setState({
        assigmentOpen: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeAssigment", function (id) {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssignments: prevState.selectedAssignments.filter(function (x) {
              return x.id !== id.id;
            }),
            hasMadeChange: true
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.deleteCalendarEvent(_this.props.match.params.id).then(function () {
            _this.redirect();
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCreateTeamsMeeting", function () {
      // Create Teamsmeeting and reload page
      var values = {
        id: _this.props.schedule.id,
        addTeamsMeeting: true
      };

      _this.setState({
        saving: true
      });

      _this.props.updateCalendarEvent(values).then(function () {
        _this.props.getScheduleItem(_this.props.match.params.id).then(function () {
          _this.setState({
            saving: false
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onJoinTeamsMeeting", function () {
      window.open(_this.props.schedule.teamsMeeting);
    });

    _defineProperty(_assertThisInitialized(_this), "onOptionsTeamsMeeting", function () {
      window.open(_this.props.schedule.teamsMeetingData.optionsUrl);
    });

    _defineProperty(_assertThisInitialized(_this), "isLoading", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "container single-task"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "noDataFound", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "container single-task"
      }, /*#__PURE__*/React.createElement("h1", null, _this.props.translate('no-results')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsHtml", function () {
      var strHtml = _this.props.schedule.teamsMeetingData.joinHtml;
      var locale = getActiveLanguage();
      strHtml = strHtml.replace('Learn more about Teams', '');

      if (locale == 'sv-se') {
        strHtml = strHtml.replace('Join Microsoft Teams Meeting', 'Anslut till Microsoft Teams-möte');
        strHtml = strHtml.replace('Meeting options', 'Mötesalternativ');
        strHtml = strHtml.replace('Learn more about Teams', 'Läs mer om Teams');
        strHtml = strHtml.replace('en-US', 'sv-SE');
      }

      strHtml = strHtml.replace('width:100%;height: 20px;', 'width:100%;height: 1px;');
      strHtml = strHtml.replace('margin-top: 24px;', 'margin-top: 5px;');
      strHtml = strHtml.replace('white-space:nowrap;color:gray;opacity:.36;', '');
      strHtml = strHtml.replace('white-space:nowrap;color:gray;opacity:.36;', '');
      strHtml = strHtml.replace('|', '');
      strHtml = strHtml.replace('________________________________________________________________________________', '<hr/>');
      strHtml = strHtml.replace('________________________________________________________________________________', '<hr/>');
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: strHtml
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsHtmlFromData", function () {
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: _this.onJoinTeamsMeeting
      }, _this.props.translate('join-teamsmeeting')), (user.isTeacher() || user.isAdministrator()) && _this.props.schedule.teamsMeetingData != null ? /*#__PURE__*/React.createElement("a", {
        onClick: _this.onOptionsTeamsMeeting
      }, _this.props.translate('options-teamsmeeting')) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsSettings", function () {
      var schedule = _this.props.schedule;
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", null, _this.props.services.teamsMeeting ? /*#__PURE__*/React.createElement("div", null, schedule.teamsMeeting != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, _this.props.schedule.teamsMeetingData.joinHtml != null ? _this.renderTeamsHtml() : _this.renderTeamsHtmlFromData()) : user.isTeacher() || user.isAdministrator() ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.onCreateTeamsMeeting,
        style: {
          marginTop: 5
        },
        disabled: _this.state.saving,
        type: "secondary"
      }, _this.state.saving ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, _this.props.translate('create-teamsmeeting'))) : null) : null);
    });

    var descriptionOpen = true;

    if (localStorage.getItem('haldor-lesson-description') != null) {
      descriptionOpen = JSON.parse(localStorage.getItem('haldor-lesson-description'));
    }

    var _locale = getActiveLanguage();

    Moment.locale(_locale);
    _this.state = {
      descriptionOpen: descriptionOpen,
      loadingSchedule: false,
      saving: false,
      editForm: false,
      createEvent: false,
      formName: '',
      lang: _locale,
      loadingAssignments: false,
      selectedAssignments: [],
      assigmentOpen: true,
      hasMadeChange: false
    };
    _this._isMounted = true;
    return _this;
  }

  _createClass(SingleLesson, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        loadingSchedule: true
      });
      this.props.getScheduleItem(this.props.match.params.id).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2$props, _this2$props$schedule, _this2$props2, _this2$props2$schedul, _this2$props$schedule2, _this2$props5, _this2$props5$schedul, _this2$props5$schedul2;

        var _this2$props3, _this2$props3$schedul, _this2$props4, _this2$props4$schedul, _this2$props6, _this2$props6$schedul, promises;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.props.setPageTitle((_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : (_this2$props$schedule = _this2$props.schedule) === null || _this2$props$schedule === void 0 ? void 0 : _this2$props$schedule.title);

                if (!(((_this2$props2 = _this2.props) === null || _this2$props2 === void 0 ? void 0 : (_this2$props2$schedul = _this2$props2.schedule) === null || _this2$props2$schedul === void 0 ? void 0 : _this2$props2$schedul.section) != null && ((_this2$props$schedule2 = _this2.props.schedule) === null || _this2$props$schedule2 === void 0 ? void 0 : _this2$props$schedule2.section.id) != 0)) {
                  _context2.next = 9;
                  break;
                }

                if (!(_this2.props.schedule.section.parentId != null)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return _this2.props.getSection((_this2$props3 = _this2.props) === null || _this2$props3 === void 0 ? void 0 : (_this2$props3$schedul = _this2$props3.schedule) === null || _this2$props3$schedul === void 0 ? void 0 : _this2$props3$schedul.section.parentId, true);

              case 5:
                _context2.next = 9;
                break;

              case 7:
                _context2.next = 9;
                return _this2.props.getSection((_this2$props4 = _this2.props) === null || _this2$props4 === void 0 ? void 0 : (_this2$props4$schedul = _this2$props4.schedule) === null || _this2$props4$schedul === void 0 ? void 0 : _this2$props4$schedul.section.id, true);

              case 9:
                if (((_this2$props5 = _this2.props) === null || _this2$props5 === void 0 ? void 0 : (_this2$props5$schedul = _this2$props5.schedule) === null || _this2$props5$schedul === void 0 ? void 0 : (_this2$props5$schedul2 = _this2$props5$schedul.relationships) === null || _this2$props5$schedul2 === void 0 ? void 0 : _this2$props5$schedul2.length) > 0) {
                  _this2.setState({
                    loadingAssignments: true
                  });

                  promises = (_this2$props6 = _this2.props) === null || _this2$props6 === void 0 ? void 0 : (_this2$props6$schedul = _this2$props6.schedule) === null || _this2$props6$schedul === void 0 ? void 0 : _this2$props6$schedul.relationships.map(function (items) {
                    var containsLetters = /[a-zA-Z]/.test(items.referenceId);

                    if (containsLetters) {
                      return new Promise(function (resolve) {
                        _this2.props.getMicrosoftAssignmentDetails(items.referenceId).then(function () {
                          if (_this2.props.details != null) {
                            _this2.props.details.section = _this2.props.group;

                            _this2.setState(function (prevState) {
                              return {
                                selectedAssignments: [].concat(_toConsumableArray(prevState.selectedAssignments), [_this2.props.details])
                              };
                            });

                            resolve(1);
                          }
                        });
                      });
                    } else {
                      return new Promise(function (resolve) {
                        _this2.props.getTaskDetails(items.referenceId).then(function () {
                          if (_this2.props.assignment) {
                            _this2.setState(function (prevState) {
                              return {
                                selectedAssignments: [].concat(_toConsumableArray(prevState.selectedAssignments), [_this2.props.assignment])
                              };
                            });

                            resolve(1);
                          }

                          _this2.props.setActiveAssignment(); // clear active assignemnet set in redux by getTaskDetails above

                        });
                      });
                    }
                  });
                  Promise.all(promises).then(function () {
                    _this2.setState({
                      loadingAssignments: false
                    });
                  });
                }

                _this2.setState({
                  loadingSchedule: false
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      if (prevState.hasMadeChange !== this.state.hasMadeChange && prevState.selectedAssignments !== this.state.selectedAssignments) {
        //save searched assigment to lesson
        this.setState({
          loadingSchedule: true
        });
        var relation = [];
        this.state.selectedAssignments.map(function (items) {
          var _items$externalID;

          var obj = {
            CalendarEventId: 0,
            ReferenceType: 'ASSIGNMENT',
            ReferenceId: (_items$externalID = items === null || items === void 0 ? void 0 : items.externalID) !== null && _items$externalID !== void 0 ? _items$externalID : items.id
          };
          relation.push(obj);
        });
        var changed = this.props.schedule;
        changed.relationships = relation;
        this.props.updateCalendarEvent(changed).then(function () {
          _this3.props.getScheduleItem(_this3.props.match.params.id);
        })["catch"](function () {});
        this.setState({
          loadingSchedule: false,
          hasMadeChange: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.props.clearScheduleItem();
      this.props.clearForecast();
    } //check how many of an assignment is locked for the students

  }, {
    key: "render",
    value: function render() {
      var _schedule$section,
          _this4 = this,
          _this$props$group,
          _this$props$group2;

      if (this.state.loadingSchedule) {
        return this.isLoading();
      } else {
        if (this.props.schedule == null) {
          return this.noDataFound();
        }
      }

      var formTitle = this.props.translate(this.state.formName);
      var _this$props2 = this.props,
          schedule = _this$props2.schedule,
          translate = _this$props2.translate;
      var user = new User(this.props.currentUser);
      var disableDelete = schedule.attendanceReported != null;

      if (this.state.formName !== 'Search assignment' && schedule.section != null) {
        var _this$props3, _this$props3$group;

        formTitle = "".concat(translate(this.state.formName), " ").concat(translate('for'), " ").concat((_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$group = _this$props3.group) === null || _this$props3$group === void 0 ? void 0 : _this$props3$group.title);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-task lesson"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.editForm,
        onClose: this.toggleEdit,
        title: this.props.translate('Edit')
      }, /*#__PURE__*/React.createElement(CalendarEvent, {
        hasDate: Moment.utc(this.props.schedule.startTime).local(),
        onSubmit: this.toggleEdit,
        onAbort: this.toggleEdit
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Expandable, {
        open: this.state.descriptionOpen,
        onChange: this.onDescriptionTogle,
        title: this.props.translate('Description')
      }, schedule.description != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(PostContent, null, schedule.description)) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, schedule.section != null && ((_schedule$section = schedule.section) === null || _schedule$section === void 0 ? void 0 : _schedule$section.title) != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.55rem'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          margin: 0,
          textDecoration: 'none',
          color: '#363636'
        },
        to: "/groups/".concat(schedule.section.id)
      }, schedule.section.title)) : null, schedule.attendanceReported != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, this.props.translate('reported')) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('time')), new DateTime(schedule.startTime).getLongDateWithTime().capitalize()), schedule.room != null && schedule.room != '' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('room')), schedule.room) : null, schedule.scheduleSubject.primaryDay != '' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('week-day')), new DateTime(schedule.startTime).getDay().capitalize()) : null, schedule.scheduleSubject.primaryLength != '' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('length')), schedule.scheduleSubject.primaryLength + ' ' + translate('minutes').toLowerCase()) : null)), this.state.selectedAssignments.length > 0 || this.state.loadingAssignments ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Expandable, {
        open: this.state.assigmentOpen,
        onChange: this.onAssigmentsToggle,
        title: this.props.translate('Assignments')
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row editor-block active",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "block--assignment-block"
      }, this.state.loadingAssignments && /*#__PURE__*/React.createElement("div", {
        className: "container single-task"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), this.state.selectedAssignments.map(function (items) {
        return /*#__PURE__*/React.createElement("div", {
          className: "assignment-resource single",
          key: items.id,
          style: {
            padding: '1.65rem'
          }
        }, /*#__PURE__*/React.createElement(DisplayAssignment, {
          useLink: true,
          displayLocked: true,
          lockedItems: _this4.getLockedStatus(items),
          remove: function remove() {
            return _this4.removeAssigment(items);
          },
          assignment: items,
          permission: !user.isStudent() ? true : false,
          customPermission: true
        }));
      }))))) : null, this.props.services.attendance && (user.isTeacher() || user.isAdministrator()) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '2rem'
        }
      }), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('report-absence')), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 -1.7rem',
          marginTop: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement(UserAbsence, {
        onSubmit: this.onAbsenceSubmit
      })))) : null), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side",
        style: {
          paddingTop: 0
        }
      }, user.isTeacher() || user.isAdministrator() || user.isPedagogue() || user.isSchoolLeader() || user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), user.isTeacher() || user.isAdministrator() ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleEdit,
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", this.props.translate('Edit')) : null, user.isTeacher() || user.isAdministrator() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onRemove,
        type: "secondary",
        disabled: disableDelete,
        style: {
          marginTop: 5
        }
      }, this.props.translate('Delete'))) : null, this.props.services.teamsMeeting ? this.renderTeamsSettings() : null, user.isTeacher() && this.props.services.advancedSchedule || user.isAdministrator() && this.props.services.advancedSchedule ? /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          style: {
            marginTop: 5
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Plus"
        }), " ", this.props.translate('Add assignment'))
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: this.searchForm
      }, this.props.translate('Search assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: this.toggleAssignment
      }, this.props.translate('Create assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: this.toggleGroupAssignment
      }, this.props.translate('Create group assignment'))) : null) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeModal,
        title: formTitle
      }, this.state.formName.includes('Search') ? /*#__PURE__*/React.createElement(AssignmentSelect, {
        filterResults: this.props.filterResults,
        onSelect: this.searchAssigment,
        includeAssignmentsWithPlans: false,
        section: this.props.group
      }) : this.state.formName.includes('group') ? /*#__PURE__*/React.createElement(AssignmentForm, {
        onAbort: this.closeModalAssignment,
        editView: false,
        cloneView: false,
        lesson: this.props.schedule,
        dontRedirect: true,
        groupid: (_this$props$group = this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.id
      }) : /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        onAbort: this.closeGroupModal,
        editView: false,
        cloneView: false,
        lesson: this.props.schedule,
        section: this.props.group,
        groupid: (_this$props$group2 = this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.id
      })));
    }
  }]);

  return SingleLesson;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    user: state.user.currentUser,
    translate: translate(state.Languages.translations),
    schedule: state.schedule.activeScheduleItem,
    currentUser: state.user.currentUser,
    languages: state.Languages.languages,
    group: state.sections.activeSection,
    createdAssignments: state.assignments.newAssignments,
    createdGroupAssignment: state.assignments.newAssignment,
    assignment: state.assignments.active_assignment,
    details: state.assignments.teamsAssignmentDetails,
    attendance: state.Absence.calendarAttendence,
    forecast: state.Absence.forecast
  };
}

export default withRouter(connect(mapStateToProps, {
  setActiveAssignment: setActiveAssignment,
  getScheduleItem: getScheduleItem,
  submitAttendence: submitAttendence,
  updateAttendance: updateAttendance,
  deleteCalendarEvent: deleteCalendarEvent,
  setPageActions: setPageActions,
  setPageTitle: setPageTitle,
  updateCalendarEvent: updateCalendarEvent,
  clearScheduleItem: clearScheduleItem,
  clearForecast: clearForecast,
  getSection: getSection,
  getMicrosoftAssignmentDetails: getMicrosoftAssignmentDetails,
  getTaskDetails: getTaskDetails
})(SingleLesson));